<template>
    <div class="map-container">
        <div id="city-landing-map" class="map"></div>
    </div>
</template>

<script>
import { Maps } from "tortilla";
import mapStylesDefault from "../vendor/google-map-snazzymaps";
//import mapStylesCounty from '../vendor/google-map-counties';
const { MarkerClusterer } = Maps.Markers;
import { createMap, createMarker, fitMapBounds, createInfoWindow } from '../utils/mapUtils';
import { getCommunityMarkerImage, getMarkerImage } from '../helpers/mapHelpers';
import { round } from '../helpers/numberHelpers';

var communityPopovercontent = function(community) {
  if (!community.banner_label) {
    switch (community.availability) {
      case 'now-selling':
        community.banner_label = 'Now Selling!';
        break;
      case 'grand-opening':
        community.banner_label = 'Grand Opening!';
        break;
      case 'closeout':
        community.banner_label = 'Builder Closeout!';
        break;
      case 'new-section':
        community.banner_label = 'New Phase Release!';
        break;
      case 'sold':
        community.banner_label = 'Sold!'
        break;
      case 'available':
        community.banner_label = 'Available!';
        break;
      case 'coming-soon':
      default:
        community.banner_label = 'Coming Soon!';
    }
  }
  if (!community.currency) {
    if (!community.price) {
      community.currency = 'TBD';
    } else {
      community.currency = `$${community.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }
  }

  if (!community.communityType) {
    if (community.property_type === 'detached') {
      community.communityType = 'Detached Homes';
    } else if (community.property_type === 'single-family') {
      community.communityType = 'Single Family Homes';
    } else if (community.property_type === 'townhome') {
      community.communityType = 'Townhomes';
    } else {
      community.communityType = 'Homes';
    }
  }
  return `<div class="list-card__list-item list-card__list-item--collapsible"><a href="${community.url}" class="list-card__list-item-wrap"><div class="list-card__item-image">
      <img alt="${community.seo_name}" src="${community.images.logo.thumb}">
  </div><div class="list-card__item-content">
      <div class="list-card__item-header">
          <div class="list-card__item-header-content">
              <h4 class="list-card__item-title">${community.name}</h4>
              <p class="list-card__item-description">
                ${community.type === 'mpc' ? 'Master Planned Community' : community.communityType} in ${community.city}
              </p>
          </div><div class="list-card__item-cta">
              <div class="list-card__faux-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14" class="svg-arrow">
        <path fill-rule="nonzero" d="M15.26 7.23H.22a.22.22 0 0 1 0-.44h15.05L8.84.37a.22.22 0 0 1 .3-.3l6.8 6.78c.06.06.08.15.05.23a.22.22 0 0 1-.06.08l-6.78 6.8a.22.22 0 0 1-.31-.31l6.42-6.42z"/></svg></div>
          </div>
      </div><div class="list-card__item-footer">
          <span class="list-card__item-pricing">From ${community.currency}</span>
          <span class="list-card__item-availability list-card__item-availability--${community.availability}">
              ${community.banner_label}
          </span>
      </div>
  </div></a></div>`;
};

var clusterPopovercontent = function(types) {
  let properties = "";

  for (const property in types) {
    properties += `
      <div class="cluster-map-key__item middle-xs">
          <img src="${getMarkerImage()}">
          <span>(${types[property].total}) ${types[property].title}</span>
      </div>
    `;
  }

  return `
    <div class="cluster-map-key row middle-xs around-xs">
      ${properties}
    </div>
  `;
};

export default {
  created() {
    events.$on("map-intialized", map => {
      map.setZoom(10);
      map.setCenter({lat: 34.050063, lng: -118.226037});
      this.$gmaps().then(gm => {
        this.gm = gm;
        this.setMapInstance(map);
        this.findCommunities();
        this.setCounties(map);
        this.initListeners();
      });
    });
  },

  mounted: function() {
    this.$eventsBus.$on('slider-range-updated', ($event) => {
        this.parameters[$event[0]] = $event[1];
        this.parameters[$event[2]] = $event[3];
        this.citySearch();
    });
    this.$eventsBus.$on('community-over', this.handleCardOver);
    this.$eventsBus.$on('community-out', this.closeInfoWindows)
  },
  beforeDestroy() {
    this.$eventsBus.$off('slider-range-updated');
    this.$eventsBus.$off('community-over', this.handleCardOver);
    this.$eventsBus.$off('community-out', this.closeInfoWindows)
  },
  props: {
    regionId: false,
    counties: String,
    clustered: {
      type: Boolean,
      default: false
    },
    displayCountyLines: {
      default: true
    },
    isActive: false
  },

  data() {
    return {
      gm: {},
      communities: [],
      mapInstance: {},
      markers: [],
      loaded: false,
      mobileMapToggle: false,
      parameters: {
        'min-price': 0,
        'max-price': 10000000
      },
      infoWindow: false,
      markerCluster: false,
      clusterInfoWindow: false
    };
  },

  computed: {
    mapStyles: function() {
      return mapStylesDefault;
    }
  },

  watch: {
    communities: function() {
      this.markers = [];
      this.communities.map(this.communityMarker).filter(a => {
        return a;
      });
      if (this.clustered) {
        this.initClusterer();
      }
    }
  },

  methods: {
    handleCardOver(id) {
      const marker = this.markers.find(obj => obj.id === `marker_${id}`);
      if (window.google !== undefined) {
        google.maps.event.trigger(marker, 'click');
      }
    },
    closeInfoWindows() {
      if (this.infoWindow) {
        this.infoWindow.close();
      }

      if (this.clusterInfoWindow) {
        this.clusterInfoWindow.close();
      }
    },
    setMapInstance: function(map) {
      this.mapInstance = map;
    },
    setCounties: function(map) {
      if (!this.displayCountyLines) {
        return;
      }
      new this.gm.KmlLayer({
        url: this.counties,
        suppressInfoWindows: true,
        clickable: false,
        preserveViewport: true,
        map
      });
    },
    setCommunities: function(result) {
      this.communities = result.data;
    },
    communityPopoverContent(community) {
      return communityPopovercontent(community);
    },
    getMarker: function(latitude, longitude) {
      const lat = round(latitude, 6);
      const lng = round(longitude, 6);

      var res = this.markers.filter(function(m) {
        const mlat = round(m.position.lat(), 6);
        const mlng = round(m.position.lng(), 6);
        return mlat === lat && mlng === lng;
      });

      if (res.length === 1) {
        return res[0];
      }

      return false;
    },
    async communityMarker(community) {
      const lat = round(community.latitude, 6);
      const lng = round(community.longitude, 6);
      if (!(lat && lng)) return false;

      if (!this.infoWindow) {
        this.infoWindow = createInfoWindow({
          maxWidth: window.innerWidth <= 767 ? 250 : 464
        });
      }

      const marker = await createMarker({
        map: this.mapInstance,
        position: { lat, lng },
        icon: getCommunityMarkerImage(community),
        size: { width: 30, height: 34 },
        title: community.name,
        className: 'community-marker'
      });

      marker.content.dataset.id = `marker_${community.id}`;
      marker.content.dataset.propertyType = JSON.stringify({
        total: 1,
        key: community.property_type,
        title: community.property_type_title
      });

      marker.addListener('click', () => {
        const content = this.communityPopoverContent(community);
        if (this.infoWindow) {
          this.infoWindow.close();
          this.infoWindow.setContent(content);
          this.infoWindow.open({
            anchor: marker,
            map: this.mapInstance
          });

          const elem = document.querySelector('.gm-style-iw').parentNode;
          const parent = elem.parentNode;
          if (parent) {
            parent.classList.add('single-popover');
          }
        }
      });

      return marker;
    },
    findCommunities: function() {
      return Tortilla.Xhr.get(`/api/regions/${this.regionId}/communities`, this.parameters).then((result) => {
        this.setCommunities(result);
        this.loaded = true;
      });

    },
    initListeners() {
      this.gm.event.addListener(this.mapInstance, "zoom_changed", () => {
        this.closeInfoWindows();
      });
      this.gm.event.addListener(this.mapInstance, "mousedown", () => {
        this.closeInfoWindows();
      });
    },
    getMarkerTypes: function(markers) {
      const types = {};
      markers.forEach(marker => {
        if (!(marker.property_type.key in types)) {
          types[marker.property_type.key] = {
            total: marker.property_type.total,
            title: marker.property_type.title
          };
        } else {
          types[marker.property_type.key].total += marker.property_type.total;
        }
      });

      return types;
    },
    handleMarkerOver(id) {
      this.$eventsBus.$emit('marker-over', id);
    },
    handleMarkerOut(id) {
      this.$eventsBus.$emit('marker-out', id);
    },
    initClusterer: function() {
      // clear the cluster markers if it exists to ensure that multiple marker
      // clusters don't exist for the same or much of the same markers
      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      }

      this.markerCluster = new MarkerClusterer(this.mapInstance, this.markers, {
        maxZoom: 10,
        minimumClusterSize: 3,
        averageCenter: true,
        styles: [
          {
            textSize: 1,
            url: "/images/site/maps/map-pin.svg",
            height: 70,
            width: 70
          }
        ]
      });

      this.clusterInfoWindow = new this.gm.InfoWindow({
        maxWidth: 400,
        pixelOffset: new this.gm.Size(0, -20)
      });

      this.addClustererListeners();
    },
    addClustererListeners: function() {
      this.gm.event.addListener(
        this.clusterInfoWindow,
        "domready",
        function() {
          const parent = document.querySelector(".gm-style-iw").parentNode;
          parent.classList.add("cluster-custom-iw");
        }
      );

      this.gm.event.addListener(
        this.markerCluster,
        "mouseover",
        cluster => {
          this.showClusterInfoWindow(cluster);
        }
      );

      this.gm.event.addListener(this.markerCluster, "mouseout", () => {
        this.clusterInfoWindow.close();
      });
    },
    showClusterInfoWindow: function(cluster) {
      const types = this.getMarkerTypes(cluster.getMarkers());

      this.closeInfoWindows();
      this.clusterInfoWindow.setContent(clusterPopovercontent(types));
      this.clusterInfoWindow.setPosition(cluster.getCenter());
      this.clusterInfoWindow.open(this.mapInstance);
    },
    async initialize() {
      try {
        this.mapInstance = await createMap('city-landing-map');
        this.infoWindow = createInfoWindow({
          maxWidth: window.innerWidth <= 767 ? 250 : 464
        });
      } catch (error) {
        console.error('Failed to initialize map:', error);
      }
    }
  }
};
</script>

<style scoped>
.map-container {
    width: 100%;
    height: 100%;
    min-height: 400px;
}
.map {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/components/apps/city-landing-page-map.vue